import { RGB } from './types';

const calculateLuminance = ({ r, g, b }: RGB) => {
  if (r < 0 || g < 0 || b < 0) {
    throw new Error('RGB values cannot be less than 0');
  }
  if (r > 255 || g > 255 || b > 255) {
    throw new Error('RGB values cannot be greater than 255');
  }

  const [red, green, blue] = [r, g, b].map(color => {
    const colorRatio = color / 255;
    return colorRatio <= 0.03928
      ? colorRatio / 12.92
      : Math.pow((colorRatio + 0.055) / 1.055, 2.4);
  });
  return red * 0.2126 + green * 0.7152 + blue * 0.0722;
};

export default calculateLuminance;
